import { useEffect } from "react";
import { MotionBox as Box } from "utils/motion";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

const BgChangeSection = ({
  initialColor,
  finalColor,
  children,
  animationId,
  start,
  end,
}) => {
  useEffect(() => {
    const isiOS = /^iP/.test(navigator.platform);
    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.defaults({
      toggleActions: "restart pause resume pause", // Scoll effect Forward, Leave, Back, Back Leave
      markers: false,
    });

    if (isiOS) {
      ScrollTrigger.config({
        autoRefreshEvents: "visibilitychange,DOMContentLoaded,load",
      });
    }
    const timelineHeader = gsap.timeline({
      scrollTrigger: {
        id: `bg-change-${animationId}`,
        trigger: `#bg-change-${animationId}`,
        scrub: 1,
        start: start || "top",
        end: end || "top -60%",
      },
    });

    timelineHeader
      .from(`#bg-change-${animationId}`, { opacity: 1 }, 0)
      .to(`#bg-change-${animationId}`, { opacity: 0 });

    return () => {
      ScrollTrigger.getById(`bg-change-${animationId}`)?.kill();
    };
  }, []);

  return (
    <Box h="100%" bg={finalColor} position="relative">
      <Box
        id={`bg-change-${animationId}`}
        opacity={1}
        position="absolute"
        bg={initialColor}
        h="100%"
        w="100%"
      />
      <Box position="relative">{children}</Box>
    </Box>
  );
};

export default BgChangeSection;
